// @flow
import React, { Component } from 'react';
import { connect } from '../../../base/redux';
import { translate } from '../../../base/i18n';
import ModalDialog, { ModalFooter, ModalHeader } from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button';
import { hideApiLoader, showApiLoader } from '../../redux/tool-webjam/actions';
import { dispatch } from '../../Utils';
import { setHostHangupEventReceived } from '../../redux/tool-webjam-v3/actions';
import TimerUI from './Timer';
import { ct } from '../../constant-Utils';
import { CURRENT_ROOM_NAME } from '../../../webjam/constant';
import { FEATURE_CUSTOM_REDUX_V3 } from '../../constant';
import { setDeviceContainerStatus } from '../../redux/tool-webjam-v2/actions';

class HostHangup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hideHostHangup: false,
        };
    }

    disconnect() {
        const { hangupActionType } = this.props
        if (hangupActionType == 1) {
            this.setState({
                hideHostHangup: true
            })
            dispatch(setHostHangupEventReceived(false, 0))
            dispatch(setDeviceContainerStatus("hostUnpair", 'HostHangup'))
        }

        if (hangupActionType == 2) {
            // Remove all localstorage
            sessionStorage.removeItem("automanagehost");
            sessionStorage.removeItem("uniqueId");
            sessionStorage.removeItem("preJoinTimer");
            localStorage.removeItem("storeDominant");
            localStorage.removeItem("makeHostConnect");
            localStorage.removeItem("thirdPartyMakeHostConnect");
            localStorage.removeItem("newRoomHosted");
            localStorage.removeItem("autopopup");
            localStorage.removeItem("makeHost");
            localStorage.removeItem("autoConnect");
            localStorage.removeItem("uniqueID");
            localStorage.removeItem("connectPop");
            localStorage.removeItem("windowRedirect");
            localStorage.removeItem("roomFound");
            sessionStorage.removeItem("dv_cnf_tm");
            sessionStorage.removeItem("up_time_" + CURRENT_ROOM_NAME);

            window.location.href = window.location.origin
        }
    }

    stayInRoom() {
        this.setState({
            hideHostHangup: true
        })
        dispatch(showApiLoader({
            loaderAdditionalDetail: ct("Translate.messages.hostHangUpProcessing"),
        }));
        setTimeout(() => {
            dispatch(showApiLoader({
                loaderAdditionalDetail: ct("Translate.messages.hostHangUpProcessing"),
            }));
        }, 2000)
        setTimeout(() => {
            dispatch(showApiLoader({
                loaderAdditionalDetail: ct("Translate.messages.hostHangUpProcessing"),
            }));
        }, 4000)
        setTimeout(() => {
            dispatch(hideApiLoader());
            dispatch(setHostHangupEventReceived(false, 0))
        }, 60000)
    }

    render() {
        const { hangupActionType } = this.props
        const { hideHostHangup } = this.state

        if (hideHostHangup) {
            return null;
        }

        return (
            <ModalDialog testId='host-hangup-popup'>
                <ModalHeader className='host-hangup-header'>
                    {hangupActionType == 1 ? ct("Translate.typography.hostDisconnectTitle") : ct("Translate.typography.hostHangupPopupTitle")}
                </ModalHeader>
                <div className="host-hangup-msg">
                    {hangupActionType == 1 ? ct("Translate.messages.hostDisconnectContent") : ct("Translate.messages.hostHangupPopupContent")}
                    <TimerUI seconds={15} />
                </div>
                <ModalFooter className='host-hangup-footer'>
                    <Button
                        className="host-hangup-stay"
                        onClick={() => { this.stayInRoom() }}>
                        {ct("Translate.buttonTitle.staySmall")}
                    </Button>
                    <Button
                        className="host-hangup-leave"
                        onClick={() => { this.disconnect() }}>
                        {hangupActionType == 1 ? ct("Translate.buttonTitle.disconnectSmall") : ct("Translate.buttonTitle.leaveSmall")}
                    </Button>
                </ModalFooter>
            </ModalDialog >
        )
    }
}

function _mapStateToProps(state) {
    return {
        hangupActionType: state[FEATURE_CUSTOM_REDUX_V3].hangupActionType,
    };
}

export default translate(connect(_mapStateToProps)(HostHangup));